// extracted by mini-css-extract-plugin
module.exports = {"modal":"ok","error":"pk","disabled":"qk","fields":"rk","footer":"sk"};